import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import { clsx } from "clsx";
import React from "react";
import { withModalsPopup } from "./withModalsPopup";

import { IconTimes } from "@bared/ui";

const wrapperStyles = {
  default: `max-w-[1000px]`,
  subscribe: `fixed bottom-0 left-0 px-0 shadow-large max-w-[300px] md:max-w-[630px]`,
  upsell: `max-w-[700px]`,
  image: `max-w-80vh max-h-full-vh px-mega xl:px-mega`,
  "size-guide": `top-0 overflow-x-hidden overflow-y-auto max-w-[800px] md:top-auto md:max-h-70vh`,
  notify: `max-w-[470px]`,
  "gift-card": `max-w-[700px] xl:px-midi`,
  "wishlist-share": `max-w-[630px]`,
  review: `max-h-full px-zero md:max-h-70vh`,
};

const Container = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "inset-0 transition-layout fixed z-100 mt-[86px] flex items-center justify-center md:mt-peta",
      props.active ? "duration-slow visible" : "invisible",
    )}
  />
);

const Bg = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "inset-0 fixed cursor-pointer bg-primary opacity-90 transition-opacity",
      props.active ? "duration-slow opacity-50" : "opacity-0",
    )}
  />
);

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "max-h-70vh xl:px-0 absolute z-20 w-full max-w-[1000px] overflow-y-auto overflow-x-hidden px-midi transition-transform",
      props.active
        ? "translate-y-0 duration-slow pointer-events-auto opacity-100"
        : "pointer-events-none translate-y-full opacity-0",
      wrapperStyles[props.layout],
    )}
  />
);

const Content = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "relative flex flex-col items-center justify-center bg-white leading-caption",
    )}
  />
);

const StyledIcon = (props: any) => (
  <IconTimes
    className={clsx(
      props.className,
      "block w-[24px] pr-nano pt-nano md:pr-micro md:pt-micro",
      props.layout === "image" && "text-white",
    )}
  />
);

const Close = withFocusRing((props: any) => (
  <button
    {...props}
    className={clsx(
      props.className,
      "right-0 top-0 absolute z-50 cursor-pointer hover:opacity-70",
    )}
  />
));

const ModalsPopup = withModalsPopup(
  ({ active, children, handleClick, layout, "data-testid": dataTestId }) => {
    return (
      <Container active={active}>
        <Bg active={active} onClick={handleClick} />
        <Wrapper layout={layout} className="hide-scrollbar" active={active}>
          <Content>
            <Close onClick={handleClick} title="close">
              <StyledIcon layout={layout} />
            </Close>
            {children}
          </Content>
        </Wrapper>
      </Container>
    );
  },
);

export default ModalsPopup;
